export default __webpack_public_path__ + "static/media/nextStepsBG.c1897a2f.webp";